var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"ezoic-ad-container"},[_c('div',{attrs:{"id":("ezoic-pub-ad-placeholder-" + _vm.id)}}),_c('span',{domProps:{"innerHTML":_vm._s(_vm.adGeneratedContent)}})])}
var staticRenderFns = []

export { render, staticRenderFns }